import React from "react";
var __jsx = React.createElement;
import stl from "./BuyItWeDeliverItSingle.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var BuyItWeDeliverItSingle = function BuyItWeDeliverItSingle(_ref) {
  var cityName = _ref.cityName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.BDC_container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.BDC_content
  }, /*#__PURE__*/React.createElement("h2", null, t("buy_get_delivered_doorstep_anywhere", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("p", null, t("modern_trucks_syarah_deliver_car_2", {
    ns: "web_city",
    cityName: cityName
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.BDC_imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/city/buy_it_we_deliver_it.webp",
    alt: "biggest collection of cars image",
    loading: "lazy",
    width: 450,
    height: 200
  }))));
};
export default BuyItWeDeliverItSingle;